import type { PaginationData } from '@/types/pagination';
import { Pagination } from '@astryxdesign/core/Pagination';
import { router } from '@inertiajs/react';

interface PaginationProps {
  pagination: PaginationData;
  /**
   * Base path for pagination URLs (e.g., '/brands')
   * This should be a function from js-routes like brands_path
   */
  pathBuilder: (params: Record<string, unknown>) => string;
  /**
   * Additional query parameters to maintain across page changes
   * (e.g., { category: 'tech', sort: 'name' })
   */
  queryParams?: Record<string, unknown>;
  /**
   * Whether to preserve the scroll position when navigating to a new page
   * @default false
   */
  preserveScroll?: boolean;
  /**
   * Whether to preserve the state when navigating to a new page
   * @default false
   */
  preserveState?: boolean;
}

const PaginatedNav = ({
  pagination,
  pathBuilder,
  queryParams = {},
  preserveScroll = false,
  preserveState = false,
}: PaginationProps) => {
  if (pagination.totalPages <= 1) {
    return null;
  }

  return (
    <Pagination
      page={pagination.page}
      totalPages={pagination.totalPages}
      onChange={(page) => {
        router.visit(pathBuilder({ ...queryParams, page }), {
          preserveScroll,
          preserveState,
        });
      }}
    />
  );
};

export default PaginatedNav;
